import React from 'react';
import { QueryHookOptions } from '@apollo/client';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import { useQuery } from '@ts-gql/apollo';

export const fragment = gql`
  fragment Client_Fragment on Client {
    cloudId
    name
    endDateUtc
    isDeleted
  }
` as import('../../__generated__/ts-gql/Client_Fragment').type;

export const GET_CLIENTS_BY_ID_QUERY = gql`
  query GetClientsByIds($cloudIds: [String!]!) {
    getClientsByIds(cloudIds: $cloudIds) {
      ...Client_Fragment
    }
  }
` as import('../../__generated__/ts-gql/GetClientsByIds').type;

export type GetClientsByIdsQueryVariables = OperationVariables<
  typeof GET_CLIENTS_BY_ID_QUERY
>;
export type GetClientsByIdsQueryResult = OperationData<
  typeof GET_CLIENTS_BY_ID_QUERY
>;

export type GetClientsByIdsItem = NonNullable<
  ReturnType<typeof processData>
>[number];

// TODO look at using readFragment and the fragment declared above to see if we already have
// any of the cloudIds cached. Only hit the network for ones we don't have. https://www.apollographql.com/docs/react/caching/cache-interaction/#readfragment
// Should be doable without changing the result, we're already returning the data property as an array of GetClientsByIdsResult
export const useGetClientsByIds = (
  options: QueryHookOptions<
    GetClientsByIdsQueryResult,
    GetClientsByIdsQueryVariables
  >
) => {
  const variables = options.variables || ({} as GetClientsByIdsQueryVariables);

  const res = useQuery<typeof GET_CLIENTS_BY_ID_QUERY>(
    GET_CLIENTS_BY_ID_QUERY,
    {
      context: { service: 'clients' },
      variables,
      ...options,
    }
  );
  const { data } = res;
  return React.useMemo(
    () => ({ ...res, data: data ? processData(data) : null }),
    [res, data]
  );
};
export function processData(data: GetClientsByIdsQueryResult) {
  const rawRows = data?.getClientsByIds;
  const result: GetClientsByIdsQueryResult['getClientsByIds'] | undefined =
    rawRows?.map((raw) => ({
      ...raw,
      endDateUtc: raw.endDateUtc && new Date(raw.endDateUtc),
    }));
  return result;
}
